import { User } from '@/payload-types'
import { UserRound } from 'lucide-react'
export const AuthorCard = ({ author }: { author: User }) => {
    return (
        <div className='relative mx-auto mb-2 border max-w-80 p-4 rounded-[5px] bg-neutral-100 border-stone-300 flex flex-grow flex-col gap-2 items-center'>
            <picture className='w-28 h-28 bg-slate-400 rounded-lg' />
            <div className='flex flex-col items-center gap-1'>
                <h2 className='text-xl text-black'>{author.name}</h2>
                <span className='flex flex-row items-center text-sm text-gray-600'>
                    <UserRound className='inline-block mr-1' size={14} />
                    <p>{author.username}</p>
                </span>
            </div>
        </div>
    )
}
